import React from 'react'
import Header from '../Components/HomePage/Header'

const NotFound = () => {
    return (
        <React.Fragment>
            <Header />
            <h1>Page Not Found </h1>
        </React.Fragment>
    )
}

export default NotFound